<template>
  <div>
    <!-- 线下弹窗 -->
    <el-dialog :title="$t('carOrder.viewDetails.title')" :visible="visible" top="15vh" width="60%" center custom-class="dialog" :before-close="cancelBut" append-to-body>
      <div v-loading="dialogLoading" class="el-dialog-body">
        <!-- 基本信息 -->
        <h2 class="title">{{ $t('carOrder.viewDetails.title_basic_info') }}</h2>
        <table class="tab1">
          <!-- 订单号 -->
          <tr>
            <th width="100px">{{ $t('carOrder.viewDetails.label_apply_no') }}：</th>
            <td class="text-left">{{ details.order_sn }}</td>
          </tr>
          <!-- 订单来源 -->
          <tr>
            <th>{{ $t('carOrder.viewDetails.label_order_source') }}：</th>
            <td class="text-left">{{ details.source_type_show }}</td>
          </tr>
          <!-- 下单时间 -->
          <tr>
            <th>{{ $t('carOrder.viewDetails.label_order_time') }}：</th>
            <td class="text-left">{{ details.time }}</td>
          </tr>
          <!-- 备注 -->
          <tr>
            <th>{{ $t('carOrder.viewDetails.label_remark') }}：</th>
            <td class="text-left">{{ details.remark ? details.remark : "-" }}</td>
          </tr>
          <!-- 订单状态 -->
          <tr>
            <th>{{ $t('carOrder.viewDetails.label_order_state') }}：</th>
            <td class="text-left"> {{ details.order_status_show }} </td>
          </tr>
          <!-- 车辆状态 -->
          <tr>
            <th>{{ $t('carOrder.viewDetails.label_car_state') }}：</th>
            <td class="text-left"> {{ car_service_status_options[details.car_service_status] }} </td>
          </tr>
          <!-- 操作 -->
          <tr>
            <th>{{ $t('carOrder.viewDetails.label_operate') }}：</th>
            <td colspan="3" class="text-left">
              <!-- 部门领导审核 免费订单&未进行部门审核 -->
              <template v-if="btnPer.offline_car_approve">
                <el-button v-if="details.is_fee == 1 && details.order_status == 1" size="mini" type="primary" icon="el-icon-bell" @click="showDialog('leader')">{{ $t('carOrder.viewDetails.btn_leader_audit') }}</el-button>
              </template>
              <!-- 调度审核 -->
              <template v-if="btnPer.offline_car_approve_dispatch">
                <el-button v-if="details.order_status == 2" size="mini" type="primary" icon="el-icon-bell" @click="showDialog('dispatch')">{{ $t('carOrder.viewDetails.btn_audit') }}</el-button>
              </template>
              <!-- 修改分配信息 -->
              <!-- <template v-if="btnPer.offline_car_dispatch">
                <el-button v-if="details.car_service_status != 4" size="mini" type="primary" plain icon="el-icon-edit" @click="showDialog('car_service')">修改分配信息</el-button>
              </template> -->
              <!-- 取消 -->
              <template v-if="$store.state.user.role_id == 1">
                <!-- 管理员 -->
                <el-button v-if="details.order_status == 4" size="mini" icon="el-icon-circle-close" @click="showDialog('cancel2')">{{ $t('carOrder.viewDetails.btn_cancel_apply') }}</el-button>
              </template>
              <template v-else-if="btnPer.offline_car_cancel">
                <!-- 非管理员 -->
                <el-button v-if="details.order_status == 1 || details.order_status == 2" size="mini" icon="el-icon-circle-close" @click="showDialog('cancel')">{{ $t('carOrder.viewDetails.btn_cancel_apply') }}</el-button>
              </template>
              <!-- 打印订单 -->
              <el-button type="primary" size="mini" icon="el-icon-printer" @click="carPrintDetail">{{ $t('carOrder.viewDetails.btn_print_order') }}</el-button>
            </td>
          </tr>
        </table>
        <!-- 预订信息 -->
        <h2 class="title">{{ $t('carOrder.viewDetails.title_reserve_info') }}</h2>
        <table class="tab1">
          <tr>
            <th>{{ $t('carOrder.carShare.header_car_brand') }}</th>
            <th>{{ $t('carOrder.carShare.header_purpose') }}</th>
            <th>{{ $t('carOrder.carShare.header_meal') }}</th>
            <th>{{ $t('carOrder.carShare.header_length') }}</th>
            <th v-if="details.is_fee != 1">{{ $t('carOrder.carShare.header_original_type') }}</th>
          </tr>
          <tr>
            <td>{{ details.product }}</td>
            <td>{{ details.purpose_id }}</td>
            <td>{{ details.package_id }}</td>
            <td>{{ details.service_time }}</td>
            <td v-if="details.is_fee != 1">{{ details.original_type }}</td>
          </tr>
        </table>

        <!-- 客人信息 -->
        <h2 class="title">{{ $t('carOrder.viewDetails.title_guest_info') }}</h2>
        <!-- 可编辑状态 -->
        <table v-if="details.car_service_status != 4" class="tab1">
          <tr>
            <!-- 用户姓名 -->
            <th>{{ $t('carOrder.carShare.header_username') }}</th>
            <!-- 联系方式 -->
            <th>{{ $t('carOrder.viewDetails.header_phone') }}</th>
            <!-- 接客地址 -->
            <th>{{ $t('carOrder.carShare.header_pickup_address') }}</th>
            <!-- 送客地址 -->
            <th>{{ $t('carOrder.viewDetails.header_send_address') }}</th>
            <!-- 备注 -->
            <th>{{ $t('carOrder.viewDetails.header_remark') }}</th>
            <!-- 接客时间 -->
            <th width="170">{{ $t('carOrder.carShare.header_pickup_time') }}</th>
            <!-- 操作 -->
            <th>{{ $t('allOrders.header_operate') }}</th>
          </tr>
          <tr>
            <!-- 用户姓名 -->
            <td>
              <el-input v-model="details.contact_person" :placeholder="$t('carOrder.enterOrder.tip_username')" :inline="true" />
            </td>
            <td>
              <el-input v-model="details.contact_info" :placeholder="$t('carOrder.enterOrder.tip_phone')" :inline="true" />
            </td>
            <td>
              <el-input v-model="details.address" type="textarea" :placeholder="$t('carOrder.enterOrder.tip_pickup_address')" :inline="true" :rows="1" />
            </td>
            <td>
              <el-input v-model="details.sent_address" type="textarea" :placeholder="$t('carOrder.enterOrder.tip_send_address')" :inline="true" :rows="1" />
            </td>
            <td>
              <el-input v-model="remark2" type="textarea" :placeholder="$t('carOrder.enterOrder.tip_remark')" :inline="true" :rows="1" />
            </td>
            <td>{{ details.stage_time }}</td>
            <!-- 保存 -->
            <td>
              <el-button v-if="btnPer.offline_car_dispatch" type="primary" size="mini" style="padding:7px 40px;" @click="updateTourist">{{ $t('allOrders.btn_save') }}</el-button>
              <template v-else>--</template>
            </td>
          </tr>
        </table>
        <!-- 不可编辑状态 -->
        <table v-else class="tab1">
          <tr>
            <!-- 用户姓名 -->
            <th>{{ $t('carOrder.carShare.header_username') }}</th>
            <!-- 联系方式 -->
            <th>{{ $t('carOrder.viewDetails.header_phone') }}</th>
            <!-- 接客地址 -->
            <th>{{ $t('carOrder.carShare.header_pickup_address') }}</th>
            <!-- 送客地址 -->
            <th>{{ $t('carOrder.viewDetails.header_send_address') }}</th>
            <!-- 接客时间 -->
            <th>{{ $t('carOrder.carShare.header_pickup_time') }}</th>
          </tr>
          <tr>
            <!-- 用户姓名 -->
            <td>{{ details.contact_person }}</td>
            <td>{{ details.contact_info }}</td>
            <td>{{ details.address }}</td>
            <td>{{ details.sent_address }}</td>
            <td>{{ details.stage_time }}</td>
          </tr>
        </table>

        <!-- 调度分配 -->
        <template v-if="details.order_status == 2 || details.order_status == 4">
          <h2 class="title" :style="red ? 'color:red' : ''">{{ $t('carOrder.viewDetails.title_dispatch') }}</h2>
          <table class="tab1">
            <tr>
              <th>{{ $t('carOrder.carShare.header_car_brand') }}</th>
              <th>{{ $t('carOrder.carShare.header_car_number') }}</th>
              <th>{{ $t('carOrder.carShare.header_driver') }}</th>
              <template v-if="details.car_service_status != 4">
                <th v-if="details.is_fee != 1" width="180">{{ $t('carOrder.viewDetails.header_amount') }}</th>
                <th>{{ $t('carOrder.viewDetails.header_remark') }}</th>
                <th>{{ $t('allOrders.header_operate') }}</th>
              </template>
            </tr>
            <!-- 未调度 -->
            <tr v-if="details.car_service_status != 4">
              <!-- 车辆 -->
              <td>
                <!-- {{ details.product }} -->
                <el-select v-model="car_id" :placeholder="$t('carOrder.enterOrde.tip_car_brand')" style="max-width:160px;" @change="changeCars">
                  <el-option v-for="(item,index) in cars" :key="index" :value="item.id" :label="item.name" />
                </el-select>
              </td>
              <!-- 车牌号 -->
              <td>
                <el-select v-model="car_license_id" style="max-width:140px;">
                  <el-option v-for="(item, index) in car_license" :key="index" :class="{'car-red':item.status == 1}" :label="item.car_license" :value="item.id" />
                </el-select>
              </td>
              <!-- 司机 -->
              <td>
                <el-select v-model="driver_id" style="max-width:170px;">
                  <el-option v-for="(item, index) in car_driver" :key="index" :label="item.name" :value="item.id" />
                </el-select>
              </td>
              <!-- 金额 -->
              <td v-if="details.is_fee != 1">
                <span :class="details.real_pay_fee_type == 'IDR' ? 'idr': 'cny'">
                  <el-input v-model="new_price" :placeholder="$t('carOrder.viewDetails.tip_amount')" :inline="true" style="max-width:100px;" />
                </span>
              </td>
              <!-- 备注 -->
              <td>
                <el-input v-model="remark" type="textarea" :placeholder="$t('carOrder.enterOrder.tip_remark')" :inline="true" :rows="1" style="width: 50%;min-width: 160px;" />
              </td>
              <!-- 保存 -->
              <td>
                <el-button v-if="btnPer.offline_car_dispatch" type="primary" size="mini" style="padding:7px 40px;" @click="getDispatch">{{ $t('allOrders.btn_save') }}</el-button>
                <template v-else>--</template>
              </td>
            </tr>
            <!-- 已调度 -->
            <tr v-else>
              <td>{{ details.product }}</td>
              <td>{{ details.car_license_show }}</td>
              <td>{{ details.driver_show }}</td>
            </tr>
          </table>
        </template>
        <!-- 审核通过 -->
        <template v-if="details.order_status == 4">
          <!-- 司机是否准时接到客人 -->
          <h2 class="title">{{ $t('carOrder.viewDetails.title_pickup_guest') }}</h2>
          <!-- 未录入 -->
          <table v-if="details.is_picked_delay == null" class="tab1">
            <tr>
              <th>{{ $t('carOrder.viewDetails.header_content') }}</th>
              <th width="220">{{ $t('allOrders.header_operate') }}</th>
            </tr>
            <tr>
              <td>
                <el-row>
                  {{ $t('carOrder.viewDetails.label_pickup_guest') }}：
                  <el-radio v-model="is_picked_delay" :label="1">{{ $t('allOrders.radio_yes') }}</el-radio>
                  <el-radio v-model="is_picked_delay" :label="0">{{ $t('allOrders.radio_no') }}</el-radio>
                </el-row>
                <el-form v-if="is_picked_delay == 0" label-width="140px" class="tab_form">
                  <el-form-item :label="$t('carOrder.viewDetails.label_real_arrive_time')+'：'" :required="is_picked_delay == 0">
                    <el-date-picker v-model="real_picked" type="datetime" :placeholder="$t('carOrder.viewDetails.tip_choose_date')" default-time="12:00:00" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss" />
                  </el-form-item>
                  <el-form-item :label="$t('carOrder.viewDetails.label_no_arrive_reason')+'：'" :required="is_picked_delay == 0">
                    <el-input v-model="delay_info" type="textarea" :rows="2" :placeholder="$t('carOrder.viewDetails.tip_enter_content')" class="w220" />
                  </el-form-item>
                </el-form>
              </td>
              <td>
                <el-button v-if="btnPer.offline_car_delay_info" type="primary" size="mini" style="padding:7px 40px;" @click="delayInfo">{{ $t('allOrders.btn_save') }}</el-button>
                <template v-else>--</template>
              </td>
            </tr>
          </table>
          <!-- 已录入 -->
          <table v-else class="tab1">
            <tr>
              <th colspan="3">{{ $t('carOrder.viewDetails.header_content') }}</th>
            </tr>
            <tr v-if="details.is_picked_delay == 1">
              <td colspan="3">{{ $t('carOrder.viewDetails.txt_arrive_on_time') }}</td>
            </tr>
            <tr v-else-if="details.is_picked_delay == 0">
              <td>{{ $t('carOrder.viewDetails.txt_not_arrive_on_time') }}</td>
              <td>{{ $t('carOrder.viewDetails.label_real_arrive_time') }} {{ details.real_picked }}</td>
              <td>{{ $t('carOrder.viewDetails.label_reason') }} {{ details.delay_info }}</td>
            </tr>
          </table>

          <!-- 超出时长/超出范围 -->
          <template v-if="details.is_fee != 1">
            <h2 class="title">{{ $t('carOrder.viewDetails.title_beyond') }}</h2>
            <table class="tab1">
              <tr>
                <th>{{ $t('carOrder.viewDetails.header_content') }}</th>
                <th width="220">{{ $t('allOrders.header_operate') }}</th>
              </tr>
              <tr>
                <td>
                  <el-form label-width="140px" class="tab_form2">
                    <el-form-item :label="$t('carOrder.viewDetails.label_beyond_time')">
                      <el-radio-group v-model="price_type1">
                        <el-radio-button :label="1">
                          <template v-if="price_type1 == 1">
                            <el-input v-model="overtime_price_rmb" :placeholder="$t('carOrder.viewDetails.tip_price')" class="w120" />({{ $t('allOrders.yuan') }})
                          </template>
                          <template v-else>
                            <span class="null_price">{{ $t('carOrder.viewDetails.tip_price') }}</span>({{ $t('allOrders.yuan') }})
                          </template>
                        </el-radio-button>
                        <el-radio-button :label="2">
                          <template v-if="price_type1 == 2">
                            <el-input v-model="overtime_price_idr" v-focus="price_type1 == 2" :placeholder="$t('carOrder.viewDetails.tip_price')" class="w120" />(Rp)
                          </template>
                          <template v-else>
                            <span class="null_price">{{ $t('carOrder.viewDetails.tip_price') }}</span>(Rp)
                          </template>
                        </el-radio-button>
                      </el-radio-group>
                    </el-form-item>
                    <el-form-item :label="$t('carOrder.viewDetails.label_beyond_range')">
                      <el-radio-group v-model="price_type2">
                        <el-radio-button :label="1">
                          <template v-if="price_type2 == 1">
                            <el-input v-model="overrange_price_rmb" :placeholder="$t('carOrder.viewDetails.tip_price')" class="w120" />({{ $t('allOrders.yuan') }})
                          </template>
                          <template v-else>
                            <span class="null_price">{{ $t('carOrder.viewDetails.tip_price') }}</span>({{ $t('allOrders.yuan') }})
                          </template>
                        </el-radio-button>
                        <el-radio-button :label="2">
                          <template v-if="price_type2 == 2">
                            <el-input v-model="overrange_price_idr" v-focus="price_type2 == 2" :placeholder="$t('carOrder.viewDetails.tip_price')" class="w120" />(Rp)
                          </template>
                          <template v-else>
                            <span class="null_price">{{ $t('carOrder.viewDetails.tip_price') }}</span>(Rp)
                          </template>
                        </el-radio-button>
                      </el-radio-group>
                    </el-form-item>
                  </el-form>
                </td>
                <td>
                  <el-button v-if="btnPer.offline_car_over_fee" type="primary" size="mini" style="padding:7px 40px;" @click="overFee">{{ $t('allOrders.btn_save') }}</el-button>
                  <template v-else>--</template>
                </td>
              </tr>
            </table>
          </template>
        </template>

        <!-- 结算信息 -->
        <template v-if="details.is_fee != 1">
          <h2 class="title">{{ $t('carOrder.viewDetails.title_settlement_info') }}</h2>
          <table class="tab1">
            <tr>
              <th>{{ $t('carOrder.viewDetails.header_type') }}</th>
              <th>{{ $t('carOrder.viewDetails.header_settle_method') }}</th>
              <!-- <th>{{ $t('carOrder.viewDetails.header_settle_currency') }}</th> -->
              <th>{{ $t('carOrder.viewDetails.header_pay_method') }}</th>
              <th>{{ $t('carOrder.viewDetails.header_pay_amount') }}</th>
            </tr>
            <tr v-for="(item, index) in details.settle" :key="index">
              <td>{{ item.name }}</td>
              <td>{{ $t('carOrder.viewDetails.txt_undertheline') }}</td>
              <!-- <td>{{ item.real_pay_fee_type == 'RMB' ? 'CNY' : item.real_pay_fee_type }}</td> -->
              <td>{{ $t('carOrder.viewDetails.txt_undertheline') }}</td>
              <td>
                <span :class="item.real_pay_fee_type == 'IDR' ? 'idr': 'cny'">{{ numFormat(parseFloat(item.order_amount)) }}</span>
              </td>
            </tr>
          </table>
        </template>

        <!-- 订单日志 -->
        <h2 class="title">{{ $t('carOrder.viewDetails.title_order_log') }}</h2>
        <table class="tab1">
          <tr>
            <!-- 操作时间 -->
            <th>{{ $t('carOrder.viewDetails.header_operate_time') }}</th>
            <!-- 操作人 -->
            <th>{{ $t('carOrder.viewDetails.header_operate_name') }}</th>
            <!-- 操作类型 -->
            <th>{{ $t('carOrder.viewDetails.header_operate_type') }}</th>
            <!-- 订单状态 -->
            <th>{{ $t('carOrder.carShare.header_order_state') }}</th>
            <!-- 备注 -->
            <th>{{ $t('carOrder.viewDetails.header_remark') }}</th>
          </tr>
          <tr v-for="(item, index) in details.log" :key="index">
            <!-- 操作时间 -->
            <td>{{ item.created }}</td>
            <!-- 操作人 -->
            <td>{{ item.username }}</td>
            <!-- 操作类型 -->
            <td>{{ item.action }}</td>
            <!-- 订单状态 -->
            <td>{{ item.status }}</td>
            <!-- 备注 -->
            <td>{{ item.remark }}</td>
          </tr>
        </table>
      </div>
    </el-dialog>

    <!-- 操作备注弹窗 -->
    <el-dialog v-if="details" :visible.sync="reasonVisible" top="20vh" width="40%" custom-class="resonDialog">
      <!-- 部门领导审核 -->
      <div v-if="dialogType === 'leader'" class="el-dialog-body">
        <el-form>
          <el-form-item :label="$t('carOrder.viewDetails.label_is_pass')">
            <el-radio-group v-model="examine_status">
              <el-radio :label="1">{{ $t('carOrder.viewDetails.radio_leader_pass') }}</el-radio>
              <el-radio :label="0">{{ $t('carOrder.viewDetails.radio_leader_no_pass') }}</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item :label="$t('carOrder.viewDetails.label_examine_reasons')" :required="examine_status == 1 ? false : true">
            <el-input v-model="remark" type="textarea" :placeholder="$t('carOrder.enterOrder.tip_remark')" class="filter-item" style="width:80%;" clearable />
          </el-form-item>
        </el-form>
        <div slot="footer" class="text-center">
          <el-button type="primary" @click="approve">{{ $t('allOrders.btn_sure') }}</el-button>
          <el-button @click="reasonVisible = false">{{ $t('allOrders.btn_cancel') }}</el-button>
        </div>
      </div>
      <!-- 调度审核 -->
      <div v-else-if="dialogType === 'dispatch'" class="el-dialog-body">
        <el-form>
          <el-form-item :label="$t('carOrder.viewDetails.label_is_pass')">
            <el-radio-group v-model="examine_status">
              <el-radio :label="1">{{ $t('carOrder.viewDetails.radio_pass_dispatch') }}</el-radio>
              <el-radio :label="0">{{ $t('carOrder.viewDetails.radio_no_pass_dispatch') }}</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item :label="$t('carOrder.viewDetails.label_examine_reasons')" :required="examine_status == 1 ? false : true">
            <el-input v-model="remark" type="textarea" :placeholder="$t('carOrder.enterOrder.tip_remark')" class="filter-item" style="width:80%;" clearable />
          </el-form-item>
        </el-form>
        <div slot="footer" class="text-center">
          <el-button type="primary" @click="approveDispatch">{{ $t('allOrders.btn_sure') }}</el-button>
          <el-button @click="reasonVisible = false">{{ $t('allOrders.btn_cancel') }}</el-button>
        </div>
      </div>
      <!-- 取消订单 -->
      <div v-else-if="dialogType === 'cancel'" class="el-dialog-body">
        <el-form>
          <el-form-item :label="$t('carOrder.viewDetails.label_cancel_reasons')" :required="true">
            <el-input v-model="remark" type="textarea" :placeholder="$t('carOrder.viewDetails.tip_cancel_reasons')" class="filter-item" style="width:80%;" clearable />
          </el-form-item>
        </el-form>
        <div slot="footer" class="text-center">
          <el-button type="primary" @click="carCancel">{{ $t('allOrders.btn_sure') }}</el-button>
          <el-button @click="reasonVisible = false">{{ $t('allOrders.btn_cancel') }}</el-button>
        </div>
      </div>
      <!-- 取消订单(管理员) -->
      <div v-else-if="dialogType === 'cancel2'" class="el-dialog-body">
        <el-form>
          <el-form-item :label="$t('carOrder.viewDetails.label_cancel_reasons')" :required="true">
            <el-input v-model="remark" type="textarea" :placeholder="$t('carOrder.viewDetails.tip_cancel_reasons')" class="filter-item" style="width:80%;" clearable />
          </el-form-item>
        </el-form>
        <div slot="footer" class="text-center">
          <el-button type="primary" @click="carCancel2">{{ $t('allOrders.btn_sure') }}</el-button>
          <el-button @click="reasonVisible = false">{{ $t('allOrders.btn_cancel') }}</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { numFormat } from '@/utils/com'
// import Cookies from 'js-cookie'
import {
  getDetail, // 获取订单详情
  approve, // 部门领导审核订单
  approveDispatch, // 订单调度审核
  carCancel, // 职员取消订单
  carCancel2, // 管理员取消订单
  getDispatch, // 调度信息更新
  delayInfo, // 客人接送信息更新
  overFee, // 超出时间、范围信息录入
  getLicense, // 指定车队，获取车牌号
  getDriverList, // 司机数据接口
  getCarList, // 获取车型
  getAddInfo, // 获取套餐价格表
  updateTourist // 客人信息更新
} from '@/api/car'
export default {
  directives: {
    // 注册一个局部的自定义指令 v-focus
    focus: {
      // 指令的定义
      inserted: function(el) {
        // 聚焦元素
        el.querySelector('input').focus()
      }
    }
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    orderid: {
      type: Number,
      default: null
    },
    btnPer: {
      type: Object,
      default: undefined
    }
  },
  data() {
    return {
      dialogLoading: false,
      reasonVisible: false,
      remark: '',
      remark2: '',
      details: {},
      dialogType: '',
      packageList: null,
      offline: true, // 默认为线下订单详情
      examine_status: 1, // 是否通过 1:通过, 0:不通过
      is_picked_delay: null, // 司机是否准时 1:是, 0:否
      real_picked: undefined, // 实际达到时间
      delay_info: undefined, // 未准时到达原因
      price_type1: 1, // 超过时长 1:RMB, 2:RP
      price_type2: 1, // 超出范围类型 1:RMB, 2:RP
      cars: [], // 车型列表
      car_id: undefined, // 车型
      car_license: [], // 车牌号list
      car_license_id: undefined, // 车牌号
      car_driver: [], // 司机list
      driver_id: undefined, // 司机
      overtime_price_rmb: undefined, // 超时人民币费用
      overtime_price_idr: undefined, // 超时印尼币费用
      overrange_price_rmb: undefined, // 超范围人民币费用
      overrange_price_idr: undefined, // 超范围印尼币费用
      new_price: undefined, // 新费用
      price_options: [], // 价格表
      red: false,
      // 车辆使用状态
      car_service_status_options: {
        0: this.$t('allOrders.btn_all'), // '全部',
        1: this.$t('carOrder.carShare.btn_wait_distribution'), // '待分配',
        2: this.$t('carOrder.carShare.btn_wait_used'), // '待使用',
        3: this.$t('carOrder.carShare.btn_using'), // '使用中',
        4: this.$t('carOrder.carShare.btn_finished') // '使用完毕'
      },
      printDetail: {}
    }
  },
  created() {
    // console.log(this.orderid, 9999)
    this.getList()
    // this.getPackageList()
  },
  methods: {
    numFormat(val) {
      return numFormat(val)
    },
    /** 获取详情信息 */
    getList() {
      this.dialogLoading = true
      let data = {
        data: {
          order_id: this.orderid
        }
      }
      getDetail(data)
        .then(res => {
          // 下线订单详情
          this.details = { ...res.data }
          this.car_id = parseInt(res.data.car_id)
          this.car_license_id = res.data.car_license_id == 0 ? undefined : res.data.car_license_id
          this.driver_id = res.data.driver_id == 0 ? undefined : res.data.driver_id
          this.new_price = res.data.real_amount
          // 可调度分配时,获取车牌号 司机
          if (res.data.car_service_status != 4) {
            let data = {
              data: {
                car_id: res.data.car_id,
                start_time: this.details.stage_time,
                service_time: this.details.service_time,
                is_operation: 1
              }
            }
            // 车型
            getCarList().then(response => {
              this.cars = response.data
            })
            // 车牌
            getLicense(data).then(res2 => {
              this.car_license = [...res2.data]
              // console.log.log(this.car_license, 5543)
            })
            // 司机
            getDriverList({}).then(res2 => {
              this.car_driver = [...res2.data]
            })
          }
          this.dialogLoading = false
        })
        .catch(() => {
          this.dialogLoading = false
        })
    },

    /** 改变车型 */
    changeCars(val) {
      let that = this
      this.car_license_id = undefined
      let data = {
        data: {
          car_id: val,
          start_time: this.details.stage_time,
          service_time: this.details.service_time,
          is_operation: 1
        }
      }
      getLicense(data).then(res2 => {
        this.car_license = [...res2.data]
        // console.log.log(this.car_license, 887)
      })
      // 获取当前车型与套餐对应的价格
      if (this.details.is_fee != 1) {
        // 非免费
        if (this.price_options.length == 0) {
          // 未获取价格表
          getAddInfo({}).then(res => {
            this.price_options = [...res.data.price_options]
            getNewPrice(res.data.price_options)
          })
        } else {
          getNewPrice(this.price_options)
        }
      }
      function getNewPrice(price_options) {
        let has = false
        price_options.forEach((item, index) => {
          if (
            that.details.product_model_id == item.package_id &&
            val == item.product_id &&
            that.details.service_time == item.service_time
          ) {
            that.new_price = item[that.details.original_key]
            has = true
          }
        })
        if (!has) {
          that.$message.error(this.$t('carOrder.viewDetails.tip_nocar'))
          that.new_price = undefined
        }
      }
    },

    /** 部门领导审核 */
    approve() {
      if (this.examine_status == 0 && !this.remark) {
        this.$message.error(this.$t('carOrder.enterOrder.tip_remark'))
        return
      }
      this.dialogLoading = true
      let data = {
        data: {
          order_id: this.orderid,
          is_pass: this.examine_status,
          remark: this.remark
        }
      }
      approve(data)
        .then(res => {
          this.$message.success(this.$t('carOrder.viewDetails.tip_leader_audit_pass'))
          this.successF()
        })
        .catch(() => {
          this.failF()
        })
    },

    /** 订单调度审核 */
    approveDispatch() {
      if (this.examine_status == 0 && !this.remark) {
        this.$message.error(this.$t('carOrder.enterOrder.tip_remark'))
        return
      }
      this.dialogLoading = true
      let data = {
        data: {
          order_id: this.orderid,
          is_pass: this.examine_status,
          remark: this.remark
        }
      }
      approveDispatch(data)
        .then(res => {
          this.$message.success(this.$t('carOrder.viewDetails.tip_complete_audit'))
          this.successF()
        })
        .catch(() => {
          this.failF()
        })
    },

    /** 职员取消申请 */
    carCancel() {
      if (!this.remark) {
        this.$message.error(this.$t('carOrder.viewDetails.tip_cancel_reasons'))
        return
      }
      this.dialogLoading = true
      let data = {
        data: {
          order_id: this.orderid,
          remark: this.remark
        }
      }
      carCancel(data)
        .then(res => {
          this.$message.success(this.$t('allOrders.tip_cancel_suc'))
          this.successF()
        })
        .catch(() => {
          this.failF()
        })
    },

    /** 管理员取消申请 */
    carCancel2() {
      if (!this.remark) {
        this.$message.error(this.$t('carOrder.viewDetails.tip_cancel_reasons'))
        return
      }
      this.dialogLoading = true
      let data = {
        data: {
          order_id: this.orderid,
          remark: this.remark
        }
      }
      carCancel2(data)
        .then(res => {
          this.$message.success(this.$t('allOrders.tip_cancel_suc'))
          this.successF()
        })
        .catch(() => {
          this.failF()
        })
    },

    /** 调度信息更新 */
    getDispatch() {
      this.dialogLoading = true
      let data = {
        data: {
          order_id: this.orderid,
          car_id: this.car_id,
          license_id: this.car_license_id,
          driver_id: this.driver_id,
          real_amount: this.new_price,
          remark:
            (this.details.remark ? this.details.remark + ';' : '') +
            (this.remark ? this.remark : '')
        }
      }
      getDispatch(data)
        .then(res => {
          this.$message.success(this.$t('carOrder.viewDetails.tip_dispatch_update_suc'))
          this.successF2()
          this.red = false
          this.remark = undefined
        })
        .catch(() => {
          this.failF()
        })
    },

    /** 客人信息更新 */
    updateTourist() {
      this.dialogLoading = true
      let data = {
        data: {
          order_id: this.orderid,
          contact_person: this.details.contact_person,
          contact_info: this.details.contact_info,
          address: this.details.address,
          sent_address: this.details.sent_address,
          remark:
            (this.details.remark ? this.details.remark + ';' : '') +
            (this.remark2 ? this.remark2 : '')
        }
      }
      updateTourist(data)
        .then(res => {
          this.$message.success(this.$t('carOrder.viewDetails.tip_guest_update_suc'))
          this.successF2()
          this.red = false
          this.remark2 = undefined
        })
        .catch(() => {
          this.failF()
        })
    },

    /** 客人接送信息更新 */
    delayInfo() {
      // 未准时接到客人时
      if (this.is_picked_delay == 0) {
        // 提交数据为空时
        if (!this.real_picked) {
          this.$message.error(this.$t('carOrder.viewDetails.tip_choose_arrive_time'))
          return
        }
        if (!this.delay_info) {
          this.$message.error(this.$t('carOrder.viewDetails.tip_choose_reason'))
          return
        }
      }
      this.dialogLoading = true
      let data = {
        data: {
          order_id: this.orderid,
          is_delay: this.is_picked_delay,
          delay_reason: this.delay_info,
          real_stage_time: this.real_picked
        }
      }
      delayInfo(data)
        .then(res => {
          this.$message.success(this.$t('carOrder.viewDetails.tip_guest_update_suc'))
          this.successF2()
          this.getList()
        })
        .catch(() => {
          this.failF()
        })
    },

    /** 超出时间、范围信息录入 */
    overFee() {
      // 有输入价格时
      if (
        this.overtime_price_rmb ||
        this.overtime_price_idr ||
        this.overrange_price_rmb ||
        this.overrange_price_idr
      ) {
        this.dialogLoading = true
        let data = {
          data: {
            order_id: this.orderid,
            overtime_price_rmb: undefined,
            overtime_price_idr: undefined,
            overrange_price_rmb: undefined,
            overrange_price_idr: undefined
          }
        }
        switch (this.price_type1) {
          case 1:
            data.data.overtime_price_rmb = this.overtime_price_rmb
            break
          case 2:
            data.data.overtime_price_idr = this.overtime_price_idr
            break
          default:
            break
        }
        switch (this.price_type2) {
          case 1:
            data.data.overrange_price_rmb = this.overrange_price_rmb
            break
          case 2:
            data.data.overrange_price_idr = this.overrange_price_idr
            break
          default:
            break
        }
        overFee(data)
          .then(res => {
            this.$message.success(this.$t('carOrder.viewDetails.tip_guest_update_suc'))
            this.successF2()
            this.price_type1 = 1 // 超过时长 1:RMB, 2:RP
            this.price_type2 = 1 // 超出范围类型 1:RMB, 2:RP
            this.overtime_price_rmb = undefined // 超时人民币费用
            this.overtime_price_idr = undefined // 超时印尼币费用
            this.overrange_price_rmb = undefined // 超范围人民币费用
            this.overrange_price_idr = undefined // 超范围印尼币费用
            this.getList()
          })
          .catch(() => {
            this.failF()
          })
      } else {
        // 无输入价格时
        this.$message.error(this.$t('carOrder.viewDetails.tip_enter_price'))
        return
      }
    },

    /** 操作成功 */
    successF() {
      this.dialogLoading = false
      this.reasonVisible = false
      this.cancelBut()
      this.$emit('fresh')
    },
    /** 操作成功2 不关闭弹窗 */
    successF2() {
      this.dialogLoading = false
      this.reasonVisible = false
      this.$emit('fresh')
    },

    /** 操作失败 */
    failF() {
      this.dialogLoading = false
      this.reasonVisible = false
    },

    /** 填写操作备注 */
    showDialog(type) {
      // 调度审核时, 必须已经调度分配
      if (type == 'dispatch' && this.details.car_license_id == 0) {
        this.$message.error(this.$t('carOrder.viewDetails.tip_complete_dispatch_first'))
        this.red = true
        return
      }
      this.dialogType = type
      this.remark = undefined
      this.reasonVisible = true
      this.examine_status = 1
    },

    /** 关闭弹窗/取消 */
    cancelBut() {
      if (this.isfix) this.fresh()
      this.$emit('cancelBut')
    },

    /** 操作成功后,刷新父页面订单列表 */
    fresh() {
      this.$emit('fresh')
    },

    /** 打开新页面打印 */
    carPrintDetail() {
      this.printDetail = {
        order_sn: this.details.order_sn, // 订单号
        company_id: this.details.source_type_show, // 来源
        time: this.details.time, // 下单时间
        remark: this.details.remark ? this.details.remark : '-', // 备注
        order_status: this.details.order_status, // 订单状态
        order_status_show: this.details.order_status_show, // 订单状态(文字)
        car_service_status: this.car_service_status_options[this.details.car_service_status], // 车辆状态
        product: this.details.product, // 车辆品牌
        purpose_id: this.details.purpose_id, // 用途
        package_id: this.details.package_id, // 套餐内容
        service_time: this.details.service_time, // 时长
        is_fee: this.details.is_fee, // 是否免费
        original_type: this.details.original_type, // 原单类型
        contact_person: this.details.contact_person, // 用户姓名
        contact_info: this.details.contact_info, // 联系方式
        address: this.details.address, // 接客地点
        sent_address: this.details.sent_address, // 送客地点
        stage_time: this.details.stage_time, // 接客时间
        car_license_id: this.details.car_license_show, // 车牌号
        driver_id: this.details.driver_show, // 司机
        is_picked_delay: this.details.is_picked_delay, // 司机是否准时接到客人
        real_picked: this.details.real_picked,
        delay_info: this.details.delay_info,
        settle: this.details.settle // 结算信息
      }
      localStorage.setItem('printDetails', JSON.stringify(this.printDetail))
      let routeData = this.$router.resolve({
        path: '/carPrintView'
      })
      window.open(routeData.href, '_blank')
    }
  }
}
</script>

<style lang="scss">
.PackageDetail {
  line-height: 2;
  .tit {
    background: #f1f1f1;
  }
  .item {
    & + .item {
      border-top: 1px solid #f1f1f1;
    }
    &:hover {
      background: #daecff;
    }
  }
  .item2 {
    border-top: 1px solid #f1f1f1;
    &:hover {
      background: #c6e2ff;
    }
  }
}
.dialog {
  min-width: 1150px;
}
.el-select-dropdown__item.car-red {
  color: red;
}
</style>
